const map = {
	"./img_1.avif": 8623,
	"./img_10.avif": 1749,
	"./img_11.avif": 3302,
	"./img_12.avif": 3151,
	"./img_13.avif": 176,
	"./img_14.avif": 5425,
	"./img_15.avif": 802,
	"./img_16.avif": 363,
	"./img_17.avif": 2252,
	"./img_18.avif": 7181,
	"./img_19.avif": 8446,
	"./img_2.avif": 2102,
	"./img_20.avif": 8894,
	"./img_21.avif": 7005,
	"./img_22.avif": 8264,
	"./img_23.avif": 791,
	"./img_24.avif": 3770,
	"./img_25.avif": 2889,
	"./img_26.avif": 9604,
	"./img_27.avif": 4563,
	"./img_28.avif": 7526,
	"./img_29.avif": 8901,
	"./img_3.avif": 8197,
	"./img_30.avif": 4407,
	"./img_4.avif": 4588,
	"./img_5.avif": 6411,
	"./img_6.avif": 4242,
	"./img_7.avif": 1505,
	"./img_8.avif": 7032,
	"./img_9.avif": 535
};


function webpackContext(req) {
	const id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		const e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1260;